// System directives

'use client';

// System dependencies

import React, { useEffect, useState } from 'react';
import { ThemeProvider as NextThemeProvider, ThemeProviderProps as NextThemeProviderProps } from 'next-themes';

// Props

interface FormThemeProviderProps extends NextThemeProviderProps {
  children: React.ReactNode;
}

const FormThemeProvider: React.FC<FormThemeProviderProps> = ({ children, ...props }) => {
  // Application state

  const [mounted, setMounted] = useState(false);

  // ---------------------------------------------------------------------------------------------------------------------------------------
  // useEffect to handle the setting of the mounted state
  // ---------------------------------------------------------------------------------------------------------------------------------------

  useEffect(() => {
    setMounted(true);
  }, []);

  // ---------------------------------------------------------------------------------------------------------------------------------------
  // Form interaction and rendering
  // ---------------------------------------------------------------------------------------------------------------------------------------

  if (!mounted) {
    return <>{children}</>;
  }

  return <NextThemeProvider {...props}>{children}</NextThemeProvider>;
};

export default FormThemeProvider;
